import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SpacierArcadeModeData} from "../server/data/SpacierArcadeModeData";
import {SpacierArcadeGameConfig} from "../SpacierArcadeGameConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {TimelineMax} from "gsap";
import {IShakeConfig} from "../winpresentation/multiplieraddup/SAMultiplierAddupView";

export class SAHelper extends Helper{
    public static getSymbolPositions(reelId:number, symId:number, realSymbolPosition:boolean = false, device?:string, isFreeSpin:boolean = false):[number, number] {
        if(!device) {
            device = UserAgent.deviceName;
        }
        const reelAreaPositions:[number, number] = [GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_POS_Y];
        const symbolPositionsOnReelArea:[number, number] = SAHelper.getSymbolPositionsOnReelArea(reelId, symId, realSymbolPosition, device, isFreeSpin);
        return [reelAreaPositions[0] + symbolPositionsOnReelArea[0], reelAreaPositions[1] + symbolPositionsOnReelArea[1]];
    }

    public static getSymbolPositionsOnReelArea(reelId:number, symId:number, realSymbolPosition:boolean = false, device?:string, isFreeSpin:boolean = false):[number, number] {
        if(!device) {
            device = UserAgent.deviceName;
        }
        const reelPositions:number[] = GameConfig.instance.REEL_DISPLAY_POSITIONS[reelId];
        let posY:number = (isFreeSpin || SpacierArcadeModeData.instance.isFreespin)? 0 : reelPositions[1];
        let symHeight:number = (isFreeSpin || SpacierArcadeModeData.instance.isFreespin)? SpacierArcadeGameConfig.instance.SYMBOL_HEIGHT_FREESPIN : GameConfig.instance.SYMBOL_HEIGHT;
        if(realSymbolPosition) {
            try {
                const symbol:StateReelSymbol | null = Reels.getSymbol(reelId, symId, false);
                if(symbol) {
                    return [reelPositions[0] + symbol.x, posY + symbol.y];
                }
            } catch(e) {
                // move to the next step.
            }
        }

        const symbolStep:number = Reels.getReel(reelId) != null && Reels.getReel(reelId)!.symStep != null ? Reels.getReel(reelId)!.symStep! : symHeight + GameConfig.instance.SYMBOL_BOTTOM_PADDING;
        return [reelPositions[0], posY + symbolStep * symId + symHeight / 2];
    }

    public static Shake(config:IShakeConfig):TimelineMax{
        let startPosY:number = config.obj.y;
        let startPosX:number = config.obj.x;

        let t:boolean = true;
        const tl:TimelineMax = new TimelineMax({
            onStart:() => {
                startPosY = config.obj.y;
                startPosX = config.obj.x;
            },
            onComplete:() => {
                config.obj.y = startPosY;
                config.obj.x = startPosX;
                if(config.positionCb){
                    config.obj.x = config.positionCb().x;
                    config.obj.y = config.positionCb().y;
                }
            },
            onUpdate:() => {
                const nt:number = tl.progress();
                const lt:number = tl.time();
                let et:number = config.ease ? config.ease.getRatio(nt) as number : nt;
                if(t){
                    t = false;
                    return;
                }
                if(config.positionCb){
                    startPosX = config.positionCb().x;
                    startPosY = config.positionCb().y;
                }

                if(config.reverseEase)
                    et = 1 - et;
                if(config.Intensity){
                    if(config.y != 0)
                        config.obj.y = startPosY + Math.cos(lt*config.hertz) * (config.Intensity*et)  * config.y;
                    if(config.x != 0)
                        config.obj.x = startPosX + (Math.sin(lt*config.hertz) * (config.Intensity*et)) * config.x;
                }
                else{
                    if(config.y != 0)
                        config.obj.y = startPosY + (Math.cos(lt*config.hertz) * et) * config.y;
                    if(config.x != 0)
                        config.obj.x = startPosX + (Math.sin(lt*config.hertz) * et) * config.x;
                }
            }
        });
        tl.to(this,config.duration,{})
        return tl;
    }
}